<div class="conversation-wrapper">
    <div class="active-conversation-container" #activeConversationView>
        @for (message of activeConversationMessages; track message.messageId) {
            @if (isFeedbackPromptMessage(message)) {
                <!-- Render feedback prompt or thank you message -->
                @if (message.feedbackData && !message.feedbackData.isSubmitted) {
                    <!-- Show feedback prompt -->
                    <craig-streaming-response-feedback
                        [requestId]="message.feedbackData.targetRequestId"
                        [feedbackMessage]="message"
                    ></craig-streaming-response-feedback>
                } @else if (message.feedbackData?.isSubmitted) {
                    <!-- Show thank you message -->
                    <div class="feedback-thank-you-message">
                        {{ message.content }}
                    </div>
                }
            } @else if (isAssistantMessage(message.role)) {
                <!-- Check the message's own streaming state -->
                @if (message.streamingState?.isStreaming === true) {
                    <!-- This is the live streaming message -->
                    <craig-streaming-message
                        [conversationMessage]="message"
                        [isHistorical]="false"
                        class="streaming-message"
                    >
                    </craig-streaming-message>
                } @else {
                    <!-- This is a historical/completed message -->
                    <craig-streaming-message
                        [conversationMessage]="message"
                        [isHistorical]="true"
                        class="historical-message"
                    >
                    </craig-streaming-message>
                }
            } @else {
                <craig-streaming-user-message [message]="message.content"></craig-streaming-user-message>
            }
        }
    </div>

    <!-- ANTI-SCROLL-JACKING: Down arrow button -->
    <button
        class="scroll-to-bottom-btn"
        [hidden]="!showScrollToBottomButton"
        (click)="scrollToBottomClicked()"
        aria-label="Scroll to bottom"
        title="Scroll to bottom"
    >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 14L12 19L17 14"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</div>
